import {FormControl, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs/';

/*
 * 提取公共验证规则
 * regEmail: 邮箱
 * regMobile：手机号码
 *
 * */

const regEmail = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
const regMobile = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;

// 数字验证
export function numberValidator(control: FormControl): any {
  const reg = /^[0-9]*$/;
  const valid = reg.test(control.value);
  return valid ? null : {number: true};
}

// 个人注册用户名验证
export function userNameValidator(control: FormControl): any {
  const reg = /^[A-Za-z][0-9_A-Za-z]{3,19}$/;
  const valid = reg.test(control.value);
  return valid ? null : {userName: true};
}

// 手机号验证
export function mobileValidator(control: FormControl): any {
  const valid = regMobile.test(control.value);
  return valid ? null : {mobile: true};
}

// 手机号验证,如果值为空则验证通过
export function mobileAllowNullValidator(control: FormControl): any {
  if (control.value == null || control.value == '') {//增加为空判断，当值为空时不校验
    return null;
  }
  const valid = regMobile.test(control.value);
  return valid ? null : {mobile: true};
}

// 用户名或者手机号验证
export function userNameMobileValidator(control: FormControl): any {
  // 用户名：4-20字符，首位必须字母，支持字母数字组合
  const reg = /^[A-Za-z][0-9_A-Za-z]{3,19}$|^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
  if (control.value == null || control.value == '') {//增加为空判断，当值为空时不校验
    alert(1)
    return null;
  }
  const valid = reg.test(control.value);
  return valid ? null : {userNameMobile: true};
}

// 用户名或者手机号验证或邮箱
export function loginUserNameValidator(control: FormControl): any {
  // 用户名：4-20字符，首位必须字母，支持字母数字组合
  const reg = /^[A-Za-z][0-9_A-Za-z]{3,19}$|^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$|\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/;
  if (control.value == null || control.value == '') {//增加为空判断，当值为空时不校验
    return null;
  }
  const valid = reg.test(control.value);
  return valid ? null : {userNameMobile: true};
}

// 手机号异步验证
export function mobileAsyncValidator(control: FormControl): any {
  const reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
  const valid = reg.test(control.value);
  return Observable.of(valid ? null : {mobile: true}).delay(5000);
}

// 身份证号验证
export function identityNumberValidator(control: FormControl): any {
  if (control.value == null || control.value == '') {//增加为空判断，当值为空时不校验
    return null;
  }
  const regStr = '(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|' +
    '(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)';
  const reg = new RegExp(regStr, 'ig');
  const valid = reg.test(control.value);
  return valid ? null : {identityNumber: true};
}

// 邮箱验证
export function emailValidator(control: FormControl): any {
  const valid = regEmail.test(control.value);
  return valid ? null : {email: true};
}

// 邮箱验证,如果值为空则验证通过
export function emailAllowNullValidator(control: FormControl): any {
  if (control.value == null || control.value == '') {//增加为空判断，当值为空时不校验
    return null;
  }
  const valid = regEmail.test(control.value);
  return valid ? null : {email: true};
}


//密码验证
export function pwdValidator(control: FormControl): any {
  //const reg = /^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,16}$/;
  const valid = /[0-9]+/.test(control.value) && /[a-z]+/.test(control.value) && /[A-Z]+/.test(control.value) && control.value.indexOf(" ")<0
  && control.value.length >=8 && control.value.length <= 16 && !/(?=.*[./',;"~:`()_<>{}[\]\\\-|+=!@#$%^&*? ])/.test(control.value);
  return valid ? null : {pwdValidator: true};
}

// 确认密码验证
export function equalValidator(group: FormGroup): any {
  let arr = Object.keys(group.controls);
  const password: FormControl = group.get(arr[0]) as FormControl;
  const confirmPassword: FormControl = group.get(arr[1]) as FormControl;
  const valid: boolean = (password.value === confirmPassword.value);
  return valid ? null : {equal: true};
}

//统一社会信用代码验证
export  function unifiedSocialCreditCodeValidator(control: FormControl): any {
  const reg = /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}/g;
  const valid = reg.test(control.value);
  return valid ? null : {creditCode: true};
}

//座机电话号码校验
export function telephoneValidator(control: FormControl): any {
  const reg = /^(0[0-9]{2})-\d{8}$|^(0[0-9]{3})-\d{7,8}$|(1[345789]\d{9})$/;
  const valid = reg.test(control.value);
  return valid ? null : {phone: true};
}

//座机电话号码或者手机号校验
export function telephoneOrMobileValidator(control: FormControl): any {
  const reg = /^(0[0-9]{2})-\d{8}$|^(0[0-9]{3})-\d{7,8}$|(1[345789]\d{9})$|^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
  const valid = reg.test(control.value);
  return valid ? null : {telephoneOrMobile: true};
}

//座机电话号码或者手机号校验--增加为空验证
export function telephoneOrMobileNullValidator(control: FormControl): any {
  if(control.value == null || control.value == ''){
    return null;
  }
  const reg = /^(0[0-9]{2})-\d{8}$|^(0[0-9]{3})-\d{7,8}$|(1[345789]\d{9})$|^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
  const valid = reg.test(control.value);
  return valid ? null : {telephoneOrMobile: true};
}

//传真号码校验
export function faxValidator(control: FormControl): any {
  const reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
  const valid = reg.test(control.value);
  return valid ? null : {fax: true};
}

//网址校验
export function urlValidator(control: FormControl): any {
  // const reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)?(([Ww]{3})\.)+([A-Za-z0-9-~\/])+(\.?)+([A-Za-z0-9-~\/]+)+$/;

  /*const strRegex = "^((https|http|ftp|rtsp|mms)?://)"
    + "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@
    + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
    + "|" // 允许IP和DOMAIN（域名）
    + "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
    + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
    + "[a-z]{2,6})" // first level domain- .com or .museum
    + "(:[0-9]{1,4})?" // 端口- :80
    + "((/?)|" // a slash isn't required if there is no file name
    + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
  var reg=new RegExp(strRegex);*/

  const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;

  const valid = reg.test(control.value);
  if (control.value == null || control.value == '') {//增加为空判断，当值为空时不校验
    return null;
  }
  /*if(control.value =null){
    return {url: true};
  }else{*/
  return valid ? null : {url: true};

}

//金额校验
export function faxMoney(control: FormControl): any {
  const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
  const valid = reg.test(control.value);
  return valid ? null : {actAmount: true};
}

// 邮箱验证加非空判断，为空时不做验证
export function emailAndNotnullValidator(control: FormControl): any {
  const reg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
  const valid = reg.test(control.value);
  if (control.value == null || control.value == '') {//增加为空判断，当值为空时不校验
    return null;
  }
  return valid ? null : {emailAndNotnull: true};
}

// 邮政编码
export function postcodeValidator(control: FormControl): any {
  const reg = /^[0-9]{6}$/;
  const valid = reg.test(control.value);
  if (control.value == null || control.value == '') {//增加为空判断，当值为空时不校验
    return null;
  }
  return valid ? null : {postcode: true};
};


// 禁用admin开头的用户名、administrator
export function superNameValidator(control: FormControl): any {
  const reg = /^(admin)+/;
  const valid = !reg.test(control.value);
  if (control.value == null || control.value == '') {//增加为空判断，当值为空时不校验
    return null;
  }
  return valid ? null : {superName: true};
};



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/validators/validators.ts